const getters = {
  logged: (state) => state.logged,
  username: (state) => state.username,
  nome: (state) => state.nome,
  vinculo: (state) => state.vinculo,
  administrador: (state) => state.administrador,
  usuarioPROEX: (state) => state.usuarioPROEX,
  permissaoCriarProjetoExtensao: (state) => state.permissaoCriarProjetoExtensao
}

export default getters



// WEBPACK FOOTER //
// ./src/vuex/auth/getters.js